import { render } from "./IconTrendingUp.vue?vue&type=template&id=34c0c0cd&ts=true"
import script from "./IconTrendingUp.vue?vue&type=script&lang=ts"
export * from "./IconTrendingUp.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__